// @ts-nocheck
import { createHashRouter, Navigate } from 'react-router-dom';

import PDCContainer from '@/containers/PDCContainer';
import StartContainer from '@/containers/StartContainer';

import { routes } from './routes';

export const getRouter = translations =>
    createHashRouter([
        {
            path: routes.TABLE,
            element: <PDCContainer translations={translations} />,
        },
        {
            path: routes.START,
            element: <StartContainer translations={translations} />,
        },
        {
            path: routes.DEFAULT,
            element: <Navigate to={routes.TABLE} replace />,
        },
        {
            path: '*',
            element: <Navigate to={routes.TABLE} replace />,
        },
    ]);
